import React, { useState, useEffect, useRef } from "react";
import "./index.less";
import PageScrollList from "../../../../components/page-scroll-list";
import {
  defineShareInfoInMiniProgram,
  formatTs,
  goToPage
} from "../../../../utils/common";
import {
  getWithdrawSummary,
  getWithdrawRecord,
  getUserInfo,
  queryStationDtl,
  querySharePileInfo
} from "../../api";
import { trackGdp } from '../../../../utils/gio-report';
import Toast from "@xpeng/rc-toast";
import SharePanel from "../../../../components/share-panel";
import Empty from "../../components/empty";
import { CHARGE_CDN } from "../../../../utils/constants";
import { shareGuideTextList } from "../../types";
import { getRandomItem, generatePoster } from "../../utils";
const income = () => {
  const { origin, pathname } = window.location;
  const [amountList, setAmountList] = useState({
    wait: null,
    doing: null,
    success: null
  });
  const [stationData, setStationData] = useState<any>({})
  const [bankAccount, setBankAccount] = useState("");
  const [sharePanelVisible, setSharePanelVisible] = useState<boolean>(false);
  const [stationId, setStationId] = useState<string>();
  const [total, setTotal] = useState(null);
  const [miniShareTitle, setMiniShareTitle] = useState<string>("");
  const [shareGuideText, setShareGuideText] = useState<string>("");
  const [isCloseShare, setIsCloseShare] = useState<boolean>(true);
  // 监听当前页面是否可见
  const pageVisible = useRef(true)
  useEffect(() => {
    document.title = "收入提现";
    trackGdp("P20142", "B001");
    initRandomText();
    initData();
    getStationStatus();
    pageVisibleListener();
  }, []);

  useEffect(() => {
    defineShareInfoInMiniProgram({
      shareTitle: miniShareTitle,
      shareIcon: `${CHARGE_CDN}/sharing/mini_share_v2.jpg`,
      shareUrl: `pages/home-pile-station-detail/index?stationId=${stationId}`
    });
  }, [stationId, miniShareTitle]);

  const initData = () => {
    console.log('initData');
    getWithdrawSummary({}).then(res => {
      setAmountList({
        wait: res.data?.waitWithdrawAmount,
        doing: res.data?.doingWithdrawAmount,
        success: res.data?.successWithdrawAmount
      });
    });
    getUserInfo({}).then(res => {
      if ([0, 200].includes(res.code)) {
        setBankAccount(res.data?.userCardRelaDto?.bankAccount);
      }
    });
  }

  const getStationStatus = async () => {
    const { data } = await querySharePileInfo()
    setStationId(data?.stationId);
    const stationRes = await queryStationDtl({ stationId: data?.stationId, latitude: 0, longitude: 0 })
    if (stationRes?.data && stationRes?.code === 200) {
      setStationData(stationRes.data)
      setIsCloseShare(stationRes.data?.operationDto?.stationStatus === '03')
    }
  }

  const initRandomText = () => {
    setShareGuideText(getRandomItem(shareGuideTextList));
    setMiniShareTitle(
      "@你，不限品牌，无需购买也可享受家充，小鹏家充共享功能已开启"
    );
  };

  const renderMoney = amount => {
    // amount非数字则展示--
    if (amount === null || isNaN(amount)) {
      return <div className="money-item">- -</div>; 
    }
    return (
      <div className="money-item">
        <span className="money">{ amount >= 999999.99 ? 999999.99 : amount }</span>
        <span className="unit">元</span>
      </div>
    );
  };
  const renderOrderItem = order => {
    const statusStr = {
      1: "提现中",
      2: "提现受理成功",
      3: "提现失败"
    };
    const statusColor = {
      1: "rgba(0, 0, 0, 0.4)",
      2: "#5A960A",
      3: "#FF4D4F"
    };

    const toDetail = () => {
      trackGdp("P20142", "B004");
      goToPage(
        `${origin}${pathname}#/realization-detail?businessWithdrawId=${order.businessWithdrawId}`
      );
    };
    return (
      <div className="order-item" onClick={toDetail}>
        <div className="order-item-row">
          <div
            className="order-status"
            style={{ color: statusColor[order.status] }}
          >
            {statusStr[order.status]}
          </div>
          <div className="order-amount">¥{order.amount}</div>
        </div>
        <div className="order-item-row" style={{ marginTop: 8 }}>
          <div className="order-date">{formatTs(order.submitTime)}</div>
          <div className="order-tel">尾号{order.cardLastFour}</div>
        </div>
      </div>
    );
  };

  // 列表刷新
  const fetchOrders = async (pageNo: number): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      getWithdrawRecord({
        pageNo,
        pageSize: 10
      }).then(res => {
        resolve(res.data?.records || []);
        setTotal(res.data?.total || 0);
      });
    });
  };

  // 去提现
  const toRealization = () => {
    trackGdp("P20142", "B003");
    if (!bankAccount) {
      goToPage(`${origin}${pathname}#/bind-card`);
    } else if (amountList.wait) {
      goToPage(`${origin}${pathname}#/realization`);
    } else {
      Toast.show("暂无可提现金额");
    }
  };

  // 查看银行卡
  const toManageCard = () => {
    trackGdp("P20142", "B002");
    const path = bankAccount ? "/manage-card" : "/bind-card";
    goToPage(`${origin}${pathname}#${path}`);
  };

  // 每次返回当前TAB需要刷新当前用户数据，可能用户已经购买VIP卡/购买券包
  const pageVisibleListener = () => {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        pageVisible.current = false
      }
      if (!pageVisible.current && document.visibilityState === 'visible') {
        initData()
      }
    })
  }

  return (
    <div className="income-content">
      <div className="head-income">
        <div className="head-income-amount">
          <div>待提现</div>
          <div>提现中</div>
          <div>累计提现</div>
        </div>
        <div className="head-income-amount">
          {renderMoney(amountList.wait)}
          {renderMoney(amountList.doing)}
          {renderMoney(amountList.success)}
        </div>
        <div className="head-btn-item">
          <div className="btn" onClick={toManageCard}>
            <span>银行卡</span>
            <img
              alt=""
              className="arrow"
              src={
                "https://s.xiaopeng.com/xp-charge/mini/common/arrow-right-normal.png"
              }
            />
          </div>
          <div className="btn" onClick={toRealization}>
            <span>提现</span>
            <img
              alt=""
              className="arrow"
              src={
                "https://s.xiaopeng.com/xp-charge/mini/common/arrow-right-normal.png"
              }
            />
          </div>
        </div>
      </div>
      <div className="record-title">提现记录</div>
      <div className="record">
        {total !== 0 ? (
          <PageScrollList
            renderItem={renderOrderItem}
            fetchOrders={fetchOrders}
            total={total}
          />
        ) : (
          <div className="income-list-empty">
            <Empty
              text={shareGuideText}
              onShare={() => {
                trackGdp('P20142', 'B005')
                setSharePanelVisible(true);
              }}
              showShareBtn={!isCloseShare}
            />
          </div>
        )}
      </div>
      <SharePanel
        visible={sharePanelVisible}
        onClose={() => setSharePanelVisible(false)}
        contentClassName="pile-share-panel"
        shareInfo={{
          shareMainTitle: miniShareTitle,
          shareSubTitle: "",
          shareImgUrl: `${CHARGE_CDN}/sharing/mini_share_v2.jpg`,
          sharePageUrl: `pages/home-pile-station-detail/index?stationId=${stationId}`
        }}
        getPosterBase64Data={() => {return generatePoster(stationData);}}
        btns={["wx",'poster']}
      />
    </div>
  );
};
export default income;
